import Storefront from 'utils/storefront';
import * as queries from 'utils/storefront/queries';
import { formatBundle } from 'utils/storefront/format-resource';

export const getBundleProducts = async (product) => {
  const storefront = Storefront.getInstance();
  const id = product.id.split('/Product/')[1];

  const response = await storefront.request({
    query: queries.bundleGet(id),
    variables: {
      id,
    },
  });

  if (response?.data?.products) {
    return formatBundle(response.data.products, 'product');
  }
  return null;
};
